import DashboardComponent from "../../../components/Dashboard";

export default function DashboardScreen(){
return <DashboardComponent />
}